import { Star, Quote, ExternalLink } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { REVIEWS, RATING, CONTACT } from "@/data/content";

const Stars = ({ n, size = "h-4 w-4" }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        className={`${size} ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-200"}`}
      />
    ))}
  </div>
);

export const Yorumlar = () => (
  <section id="yorumlar" className="scroll-mt-24 bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Yorumlar</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Müşterilerimiz ne diyor?
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            Google ve Yandex üzerinden gerçek müşteri değerlendirmeleri.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-6 lg:grid-cols-3 lg:gap-8">
        <Reveal>
          <div
            data-testid="review-rating-card"
            className="flex h-full flex-col justify-between rounded-2xl bg-brand p-8 text-white shadow-lift"
          >
            <div>
              <p className="font-display text-6xl font-extrabold tracking-tight">{RATING.score}</p>
              <div className="mt-3">
                <Stars n={4} />
              </div>
              <p className="mt-4 text-sm leading-relaxed text-blue-100">{RATING.label}</p>
            </div>
            <a
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-maps-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-white/90 transition-colors hover:text-white"
            >
              Tüm yorumları oku
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </Reveal>

        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={0.1 + i * 0.1}>
            <div
              data-testid={`review-card-${i + 1}`}
              className="relative flex h-full flex-col rounded-2xl border border-slate-200 bg-slate-50 p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand/40"
            >
              <Quote className="h-8 w-8 text-brand/20" aria-hidden="true" />
              <p className="mt-4 flex-1 text-base leading-relaxed text-slate-700">"{r.comment}"</p>
              <div className="mt-6 flex items-center justify-between border-t border-slate-200 pt-5">
                <div>
                  <p className="font-display text-base font-bold text-slate-900">{r.name}</p>
                  <p className="text-xs font-medium text-slate-500">{r.source}</p>
                </div>
                <Stars n={r.rating} size="h-3.5 w-3.5" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Yorumlar;
